<div class="title-container accent-color">
  <mat-icon class="opacity-4">update</mat-icon>
  <span class="text-lg font-medium">Trip Info Update Available</span>
</div>
<mat-dialog-content>
  <div class="text-sm">Refresh to update to the latest version.</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Later</button>
  <button mat-flat-button color="primary" (click)="onReloadClick()">
    Refresh
  </button>
</mat-dialog-actions>
